import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Injector,
  Input,
} from '@angular/core';
import { ActiveModal } from '@app/modules/core-modal/models/active.modal';
import { ModalComponent } from '@app/modules/modal-components-common/modal.component';
import { ModalContentAlign } from '@app/modules/modal/modal.enums';
import { ModalButton } from '@app/modules/modal/modal.types';
import { WARNING_MESSAGE } from '@app/shared/types/enums/app-warnings.enum';
import { E2E_ATTRIBUTES } from '@app/shared/types/enums/e2e-attributes.enum';
import { I18n } from '@app/i18n/strings-keys';

import { ConfirmIconVariant } from '../confirm/confirm.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'alert',
  styleUrls: ['./alert.component.scss'],
  templateUrl: './alert.component.html',
  standalone: false,
})
export class AlertComponent extends ModalComponent {
  @Input() public modalSize = 'sm';
  @Input() public title = '';
  @Input() public message = '';
  @Input() public messageParams: Record<string, any>;
  @Input() public onClose = (): void => undefined;
  @Input() public contentAlign: ModalContentAlign = ModalContentAlign.CENTER;
  @Input() public set buttons(buttons: ModalButton[] | null) {
    if (buttons) {
      this.modalButtons = buttons;
    } else {
      // eslint-disable-next-line no-console
      console.warn(WARNING_MESSAGE.SETUP_BUTTONS);
    }
  }
  @Input() public hasIcon = false;
  @Input() public iconVariant: ConfirmIconVariant;

  @HostBinding('attr.e2e-attr')
  public e2eAttr = E2E_ATTRIBUTES.ALERT_MODAL;
  public E2E_ATTRIBUTES: typeof E2E_ATTRIBUTES = E2E_ATTRIBUTES;
  public modalButtons: ModalButton[] = [
    {
      text: I18n.CommonButtons.Close,
      style: 'x_confirm-btn x_secondary',
      e2eAttr: E2E_ATTRIBUTES.ALERT_MODAL_FOOTER_BUTTON_CLOSE,
      action: 'close',
    },
  ];

  public constructor(
    public activeModal: ActiveModal,
    injector: Injector,
  ) {
    super(injector);
  }

  public getModalClass(): Record<string, boolean> {
    return {
      'modal-alert': true,
      [`modal-size-${this.modalSize}`]: true,
    };
  }

  public buttonClick(button: ModalButton) {
    this.activeModal.execute({
      action: button.action,
      payload: button.payload,
    });

    if (button.action === 'close') {
      this.onClose?.();
    }
  }
}
